import { useMemo } from 'react';

import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { IFilterDefinition } from '@evinced-private/ui-common';

import { DEFAULT_DATE_RANGE_DAYS } from 'src/apps/dashboard/constants/DashboardFiltersDefinitions';
import { useEffectiveFilters } from 'src/apps/dashboard/helpers/FilterHelpers';
import { getScoreData } from 'src/apps/dashboard/services/mobileDashboardService';
import { ScoreDataResult } from 'src/apps/dashboard/services/queries/score/helpers/transformResults';
import { REFETCH_INTERVAL } from 'src/common/consts/QueryConfigs';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { DASHBOARD_MOBILE_SCORE_DATA } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { LabelsExcludedFromDashboard } from 'src/common/types/ConfigurationTypes';

export const useMobileScoreDataQuery = (
	filters?: IFilterOptions,
	filterDefinitions?: IFilterDefinition[],
	labelsExcludedFromDashboard?: LabelsExcludedFromDashboard
): UseQueryResult<ScoreDataResult, Error> => {
	const effectiveFilters = useEffectiveFilters(filters, filterDefinitions);

	const selectedPeriod = useMemo(() => {
		const dateRangeValue = effectiveFilters?.dateRange?.[0]?.value;
		return dateRangeValue ? Number(dateRangeValue) : DEFAULT_DATE_RANGE_DAYS;
	}, [effectiveFilters]);

	return useQuery<ScoreDataResult, Error>({
		queryKey: [
			DASHBOARD_MOBILE_SCORE_DATA,
			selectedPeriod,
			effectiveFilters,
			labelsExcludedFromDashboard
		],
		queryFn: () =>
			getScoreData(effectiveFilters, '', '', selectedPeriod, labelsExcludedFromDashboard),
		refetchInterval: REFETCH_INTERVAL
	});
};
